<template>
    <DModal
        :title="__('customers.contracts.domain_contact_details.edit_domain_contact_details')"
        is-confirm
        is-big
        :show="showModal"
        :is-awaiting-validation="true"
        @confirm="confirm"
        @close="closeModal"
    >
        <DTabs>
            <DTabItem
                :label="__('orders.woo_commerce.modals.domain_info.domain_info')"
                :active="currentTab === 0"
                @click="changeTab(0)"
            />
            <DTabItem
                :label="__('orders.woo_commerce.modals.domain_info.billing_comments')"
                :active="currentTab === 1"
                @click="changeTab(1)"
            />
        </DTabs>
        <DCard
            v-if="currentTab === 0"
        >
            <div
                v-for="(domain, index) in domains"
                :key="domain"
                class="domains-list my-2"
            >
                <div
                    :class="['p-3 mx-2 mt-2 rounded', domainHasError(index) ? 'border border-danger text-danger' : 'border border-secondary']"
                    @click="toggleDomainForm(index)"
                >
                    <span>
                        <DIcon
                            :name="domainsData[index].change_owner_data === false ? 'arrow-down' : 'arrow-up'"
                            :size="18"
                        />
                        <span class="ms-5">
                            {{ domain }}
                        </span>
                    </span>
                </div>
                <div
                    v-if="domainsData[index].change_owner_data"
                    style="padding: 20px;"
                >
                    <DFieldLoading
                        v-if="isLoading"
                        :is-loading="isLoading"
                        is-big
                        class="my-4 d-flex justify-content-center"
                    />
                    <div
                        v-else
                        class="domain-form"
                    >
                        <DFormRow
                            :label="__('customers.contracts.domain_contact_details.use_customer_data')"
                            :error="getErrorMessage(index, 'use_customer_data')"
                            is-required
                        >
                            <DSwitch
                                v-model="domainsData[index].uses_customer_data"
                                color="success"
                                variant="3d"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.firstname')"
                            :error="getErrorMessage(index, 'firstname')"
                            is-required
                        >
                            <DInput
                                id="firstname"
                                v-model="domainsData[index].firstname"
                                :placeholder="__('customers.contracts.domain_contact_details.firstname')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.lastname')"
                            :error="getErrorMessage(index, 'lastname')"
                            is-required
                        >
                            <DInput
                                id="lastname"
                                v-model="domainsData[index].lastname"
                                :placeholder="__('customers.contracts.domain_contact_details.lastname')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.company')"
                            :error="getErrorMessage(index, 'company')"
                        >
                            <DInput
                                id="company"
                                v-model="domainsData[index].company"
                                :placeholder="__('customers.contracts.domain_contact_details.company')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.email')"
                            :error="getErrorMessage(index, 'email')"
                            is-required
                        >
                            <DInput
                                id="email"
                                v-model="domainsData[index].email"
                                :placeholder="__('customers.contracts.domain_contact_details.email')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.phone')"
                            :error="getErrorMessage(index, 'phone')"
                            is-required
                        >
                            <DPhoneInput
                                id="phone"
                                v-model="domainsData[index].phone"
                                :phone-country-code-placeholder="phoneCountryCodePlaceholder"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.fax')"
                            :error="getErrorMessage(index, 'fax')"
                        >
                            <DPhoneInput
                                id="fax"
                                v-model="domainsData[index].fax"
                                :phone-country-code-placeholder="phoneCountryCodePlaceholder"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.address1')"
                            :error="getErrorMessage(index, 'address1')"
                            is-required
                        >
                            <DInput
                                id="address1"
                                v-model="domainsData[index].address1"
                                :placeholder="__('customers.contracts.domain_contact_details.address1')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.address2')"
                            :error="getErrorMessage(index, 'address2')"
                        >
                            <DInput
                                id="address2"
                                v-model="domainsData[index].address2"
                                :placeholder="__('customers.contracts.domain_contact_details.address2')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.postal_code')"
                            :error="getErrorMessage(index, 'postal_code')"
                            is-required
                        >
                            <DInput
                                id="postal_code"
                                v-model="domainsData[index].postal_code"
                                :placeholder="__('customers.contracts.domain_contact_details.postal_code')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.city')"
                            :error="getErrorMessage(index, 'city')"
                            is-required
                        >
                            <DInput
                                id="city"
                                v-model="domainsData[index].city"
                                :placeholder="__('customers.contracts.domain_contact_details.city')"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="domainsData[index].uses_customer_data === false"
                            :label="__('customers.contracts.domain_contact_details.country_code')"
                            :error="getErrorMessage(index, 'country_code')"
                            is-required
                        >
                            <DSelect
                                id="country_code"
                                v-model="domainsData[index].country_code"
                                :options="countries"
                            />
                        </DFormRow>
                        <div
                            v-if="domainsData[index].uses_customer_data === false"
                        >
                            <DRow
                                v-for="(field, arrayIndex) in domainsData[index].custom_fields"
                                :key="field.key"
                                :label="field.key"
                                class="custom-field"
                            >
                                <DCol lg="4">
                                    <DInput
                                        :id="'custom_field_key_'+index+arrayIndex"
                                        v-model="domainsData[index].custom_fields[arrayIndex].key"
                                        :placeholder="__('customers.contracts.domain_contact_details.key')"
                                    />
                                </DCol>
                                <DCol lg="6">
                                    <DInput
                                        :id="'custom_field_value_'+index+arrayIndex"
                                        v-model="domainsData[index].custom_fields[arrayIndex].value"
                                        :placeholder="__('customers.contracts.domain_contact_details.value')"
                                    />
                                </DCol>
                                <DCol lg="1">
                                    <DButton
                                        mini
                                        color="danger"
                                        icon="delete"
                                        @click="removeCustomField(index, domainsData[index].custom_fields[arrayIndex].key)"
                                    />
                                </DCol>
                            </DRow>
                            <div class="d-flex justify-content-center">
                                <DButton
                                    color="primary"
                                    icon="plus"
                                    class="rounded-circle plus-icon"
                                    @click="addCustomField(index)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DCard>
        <DCard
            v-if="currentTab === 1"
            padding
        >
            <DFormRow
                :label="''"
                is-vertical
            >
                <textarea
                    id="billing-comments-contents"
                    v-model="billingCommentsString"
                    readonly
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'
import DFieldLoading from '~@/Components/Common/DFieldLoading'
import { getCountries } from '~@/Composables/dropdowns/settings/countries.js'

// Basic
const props = defineProps({
    domains: {
        type: Array,
        default: () => { return [] }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    phoneCountryCodePlaceholder: {
        type: String,
        default: ''
    },
    billingComments: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['close-modal', 'confirm'])

const currentTab = ref(0)
const billingCommentsString = ref(props.billingComments)

function changeTab (tabIndex) {
    currentTab.value = tabIndex
}

const closeModal = () => {
    emit('close-modal')
}

// Countries dropdown
const { isLoading, countries } = getCountries()

// Domain forms functionality
const domainsData = ref({})

function initiateForm () {
    props.domains.forEach((domain, index) => {
        domainsData.value[index] = {
            domain: domain,
            change_owner_data: false,
            firstname: null,
            lastname: null,
            email: null,
            company: null,
            phone: null,
            fax: null,
            address1: null,
            address2: null,
            postal_code: null,
            city: null,
            country_code: null,
            uses_customer_data: true,
            custom_fields: []
        }
    })
}

initiateForm()

function toggleDomainForm (index) {
    domainsData.value[index].change_owner_data = !domainsData.value[index].change_owner_data
}

function confirm () {
    emit('confirm', domainsData.value)
}

function getErrorMessage (index, field) {
    if (props.errors !== null && props.errors[`domains.${index}.${field}`] !== null) {
        return props.errors[`domains.${index}.${field}`]
    }
}

function domainHasError (index) {
    if (props.errors === null) {
        return false
    }

    const keys = Object.keys(props.errors)
    keys.forEach((key) => {
        if (key.startsWith(`domains.${index}.`)) {
            return true
        }
    })

    return false
}

// Custom fields
function removeCustomField (index, key) {
    domainsData.value[index].custom_fields = domainsData.value[index].custom_fields.filter((item) => {
        return item.key !== key
    })
}

function addCustomField (index) {
    domainsData.value[index].custom_fields[domainsData.value[index].custom_fields.length] = {
        key: null,
        value: null
    }
}
</script>

<style scoped>
.domain-form {
    margin-left: 20px;
}
#billing-comments-contents {
    width: 100%;
    height: 15em;
    white-space: pre;
}
.custom-field {
    margin-bottom: 25px;
}
</style>
